import { type AppointmentStatus } from '@/api';

interface AppointmentStatusBadgeProps {
  status: AppointmentStatus;
  size?: 'sm' | 'md' | 'lg';
}

const STATUS_CONFIG: Record<
  AppointmentStatus,
  { label: string; bgColor: string; textColor: string; icon?: string }
> = {
  CREATED: { label: 'Criado', bgColor: 'bg-blue-100', textColor: 'text-blue-800' },
  WAITING_PAYMENT: { label: 'Aguardando Pagamento', bgColor: 'bg-amber-100', textColor: 'text-amber-800' },
  PAID: { label: 'Pago', bgColor: 'bg-emerald-100', textColor: 'text-emerald-800' },
  WAITING_DOCTOR: { label: 'Aguardando médico', bgColor: 'bg-yellow-100', textColor: 'text-yellow-800' },
  DOCTOR_ACCEPTED: { label: 'Aceito', bgColor: 'bg-green-100', textColor: 'text-green-800' },
  IN_PROGRESS: { label: 'Em Andamento', bgColor: 'bg-emerald-100', textColor: 'text-emerald-800' },
  FINISHED: { label: 'Finalizado', bgColor: 'bg-gray-100', textColor: 'text-gray-800' },
  COMPLETED: { label: 'Concluído', bgColor: 'bg-gray-100', textColor: 'text-gray-800' },
  CANCELLED: { label: 'Cancelado', bgColor: 'bg-red-100', textColor: 'text-red-800' },
  NO_SHOW: { label: 'Não compareceu', bgColor: 'bg-orange-100', textColor: 'text-orange-800' },
  RESCHEDULED: { label: 'Reagendado', bgColor: 'bg-indigo-100', textColor: 'text-indigo-800' },
};

const SIZE_CLASSES = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
};

export function AppointmentStatusBadge({ status, size = 'md' }: AppointmentStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.CREATED;

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${config.bgColor} ${config.textColor} ${SIZE_CLASSES[size]}`}
    >
      {config.icon && <span className="mr-1">{config.icon}</span>}
      {config.label}
    </span>
  );
}
